export default "__VITE_ASSET__d60d5981__"